import { getDefaultURLSearchRequest, URL_KEYS } from '@travel/traveler-core/utils/jrdpHelper';
import { isEmptyObject } from '@travel/utils';

import { fetchPlanList } from 'store/planList/actions';
import { fetchProviderDetails, fetchSEOData } from 'store/providerDetails/actions';

import { fetchBanner } from 'store/banner/actions';

import { URLSearchQuery } from 'Common-Types';
import { PLAN_LIST_SORT } from 'constants/sort';
import { universalRouterProps } from 'core/universalRouter/types';
import { RequestBody } from 'PlanList-Types';
import { getDefaultURLCustomListRequest, getPlanListValidSortValue } from 'utils/search';

const DEFAULT_LIMIT = 10;

export type URLParams = { pageIdentifier: string; pageNumber: number };

export default async (
  { store: { dispatch, getState } }: universalRouterProps,
  params: URLParams,
  urlParams: URLSearchQuery,
) => {
  const sortKey =
    urlParams?.[URL_KEYS.SORT] === 'recommended'
      ? PLAN_LIST_SORT.rate_plan_recommend.value
      : urlParams?.[URL_KEYS.SORT];

  let path = params?.pageIdentifier;

  const query: RequestBody = {
    ...getDefaultURLSearchRequest(urlParams),
    ...getDefaultURLCustomListRequest(urlParams),
    id: path,
    sort: getPlanListValidSortValue(sortKey),
    offset: (params.pageNumber - 1) * DEFAULT_LIMIT,
    limit: DEFAULT_LIMIT,
  };

  await Promise.all([
    dispatch(fetchBanner()),
    dispatch(fetchProviderDetails(path)),
    dispatch(fetchPlanList(query)),
  ]);
  const state = getState();
  const { planList } = state;
  const imagePlanList = !isEmptyObject(planList.planList)
    ? planList.planList.plans[0]?.media[0]?.url
    : '';

  return dispatch(fetchSEOData(imagePlanList, true, params.pageNumber));
};
